export const getAssignBundleDeggrp = (state = [], action) => {
  switch (action.type) {
    case "ASSIGNBUNDLE_DEGGRP":
      return action.payload;
    default:
      return state;
  }
};

export const getSavedBundleDetails = (state = [], action) => {
  switch (action.type) {
    case "SAVED_BUNDLES":
      return action.payload;
    default:
      return state;
  }
};
